import { AppRecordStatus } from "models/appRecord";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { RequestApi, RouteApi } from "utils";
import { Snackbar } from "components";
import { Service } from "utils/services";

interface NewFeedSlice {
  loadingStatus: AppRecordStatus;
  posts: any[];
  postIds: Set<string>;
  initFriends: any[];
  isDailogBlockOpen: boolean;
}

const initialState: NewFeedSlice = {
  loadingStatus: AppRecordStatus.loading,
  posts: [],
  postIds: new Set<string>(),
  initFriends: [],
  isDailogBlockOpen: false,
};

const newFeedSlice = createSlice({
  name: "newFeed",
  initialState,
  reducers: {
    setLoadingStatus(state, action) {
      state.loadingStatus = action.payload;
    },

    setPosts(state, action) {
      state.posts = action.payload;
    },
    setInitFriends(state, action) {
      state.initFriends = action.payload;
    },
    setIsDailogBlockOpen(state, action) {
      state.isDailogBlockOpen = action.payload;
    },
  },
});

const fetchPosts = async (existingPostIds: Set<string>, token: string): Promise<any[]> => {
  let url = RouteApi.getNewFeedWeb;
  url += `token=${token}`;
  const dataPosts = { post_ids: existingPostIds, tag: [] };
  const responses = await RequestApi(url, { data: dataPosts });
  if (responses.status === "success") {
    return responses.posts;
  } else {
  }
  return [];
};

export const initPage = createAsyncThunk("newFeed/initPage", async (_, { getState, dispatch }) => {
  try {
    const state = getState() as { newFeed: NewFeedSlice };
    const { postIds, posts } = state.newFeed;
    const newPosts = await fetchPosts(postIds, Service.token as string);
    newPosts.forEach((post) => postIds.add(post.provider_post_id));
    dispatch(setPosts([...posts, ...newPosts]));
    dispatch(setLoadingStatus(AppRecordStatus.loaded));
  } catch (error) {
    dispatch(setLoadingStatus(AppRecordStatus.loaded));
  }
});

export const { setLoadingStatus, setPosts, setInitFriends, setIsDailogBlockOpen } = newFeedSlice.actions;

const newFeedReducer = newFeedSlice.reducer;

export default newFeedReducer;
